import React, { useState, useCallback, useRef, useEffect } from "react";
import { Carousel, Image } from "react-bootstrap";
import FullscreenGallery from "./FullscreenGallery";

const SLIDE_META_HIDE_DELAY = 2500;

const imageList = [
  {
    imageName: "Gallery12New.webp",
    caption: "1958 GMC - Model 100",
    mobileCrop: true,
  },
  {
    imageName: "Gallery13New.webp",
    caption: "1955 1st Series Chevrolet - Model 3100",
    mobileCrop: true,
  },
  { imageName: "Gallery11.webp", caption: "1956 Chevrolet - Model 3100" },
  {
    imageName: "galleryOrangeNew.webp",
    caption: "1957 Chevrolet - Model 3100",
  },
  {
    imageName: "Gallery01New.webp",
    caption: "Meet Titan: Our Friendly Shop Dog",
  },
  { imageName: "GalleryNew09.webp", caption: "1959 Chevrolet - Model 3100" },
  { imageName: "GalleryNew10.webp", caption: "1959 Mercedes - Model 220 S" },
  { imageName: "Gallery02New.webp", caption: "1958 Chevrolet - Model 3124" },
  { imageName: "Gallery03New.webp", caption: "1955 GMC - Model 150" },
  { imageName: "Gallery04New.webp", caption: "1957 Chevrolet - Model 3100" },
  { imageName: "Gallery05New.webp", caption: "1957 Chevrolet - Model 3100" },
  { imageName: "Gallery06New.webp", caption: "1957 Chevrolet - Model 3100" },
  { imageName: "Gallery08New.webp", caption: "1959 Chevrolet - Model 3100" },
  { imageName: "Gallery07New.webp", caption: "Ground Breaking" },
];

const GalleryCarousel = () => {
  const [showFullscreen, setShowFullscreen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showSlideMeta, setShowSlideMeta] = useState(true);
  const hideTimerRef = useRef(null);

  const revealSlideMeta = useCallback(() => {
    setShowSlideMeta(true);
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    hideTimerRef.current = setTimeout(
      () => setShowSlideMeta(false),
      SLIDE_META_HIDE_DELAY,
    );
  }, []);

  useEffect(() => {
    revealSlideMeta();
    return () => {
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
  }, [revealSlideMeta]);

  const handleSelect = useCallback(
    (selectedIndex) => {
      setActiveIndex(selectedIndex);
      revealSlideMeta();
    },
    [revealSlideMeta],
  );

  const handleImageClick = useCallback((index, event) => {
    event.stopPropagation();
    event.preventDefault();
    setSelectedImageIndex(index);
    setShowFullscreen(true);
  }, []);

  const closeFullscreen = useCallback(() => {
    setShowFullscreen(false);
  }, []);

  const activeImage = imageList[activeIndex];

  return (
    <>
      <div className="gallery-carousel-wrapper mb-4">
        <Carousel
          pause="hover"
          touch={true}
          indicators={false}
          activeIndex={activeIndex}
          onSelect={handleSelect}
          onSlid={revealSlideMeta}
          className="enhanced-gallery-carousel"
        >
          {imageList.map((image, index) => (
            <Carousel.Item key={image.imageName}>
              <div className="gallery-stage">
                <div
                  className="gallery-image-clickable"
                  onClick={(e) => handleImageClick(index, e)}
                  onTouchEnd={(e) => {
                    e.preventDefault();
                    handleImageClick(index, e);
                  }}
                  title="Tap to view fullscreen"
                >
                  <Image
                    src={`/images/carousel/webp/${image.imageName}`}
                    alt={`Gallery Image ${index + 1}`}
                    className={`gallery-image-hover${
                      image.mobileCrop ? " gallery-image-mobile-crop" : ""
                    }`}
                    draggable={false}
                  />
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>

        <div className="gallery-footer">
          <div className="gallery-footer-caption">
            <h2 className="gallery-footer-title">{activeImage.caption}</h2>
            <p className="gallery-footer-hint small d-none d-md-block mb-0">
              Click image to view fullscreen
            </p>
            <p className="gallery-footer-hint small d-md-none mb-0">
              Tap image to view fullscreen
            </p>
          </div>

          <div className="gallery-footer-meta">
            <span className="gallery-slide-counter">
              {activeIndex + 1} / {imageList.length}
            </span>

            <div
              className={`gallery-slide-meta${
                showSlideMeta ? " is-visible" : ""
              }`}
              aria-hidden={!showSlideMeta}
            >
              {imageList.map((image, index) => (
                <button
                  key={image.imageName}
                  type="button"
                  className={`gallery-slide-indicator${
                    index === activeIndex ? " active" : ""
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                  aria-current={index === activeIndex ? "true" : undefined}
                  onClick={() => handleSelect(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <FullscreenGallery
        images={imageList}
        isOpen={showFullscreen}
        onClose={closeFullscreen}
        initialIndex={selectedImageIndex}
      />
    </>
  );
};

export default GalleryCarousel;
